var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 80",
    style: {
      enableBackground: "new 0 0 79 80"
    },
    xmlSpace: "preserve",
    width: 79,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5,13.4l-18.1,32c0,0,0,0,0,0.1l11.5,21.1c0.2,0.5,0.2,0.9,0,1.3c-0.2,0.3-0.6,0.5-1.1,0.5h-8.2 c-1.3,0-1.9-0.8-2.3-1.6c0,0-11.6-21.3-11.6-21.3c0.6-1,18.2-32.3,18.2-32.3c0.4-0.8,1-1.6,2.2-1.6v0h8.3c0.5,0,0.9,0.2,1.1,0.5 C63.7,12.5,63.7,13,63.5,13.4 M35.8,34.2C35.5,34.8,27,49.8,27,49.8c-0.4,0.8-1,1.6-2.2,1.6h-8.2c-0.5,0-0.9-0.2-1.1-0.6 c-0.2-0.3-0.2-0.8,0-1.3l8.7-15.3c0,0,0,0,0,0l-5.5-9.6c-0.2-0.5-0.3-0.9,0-1.3c0.2-0.3,0.6-0.5,1.1-0.5h8.2 c1.3,0,1.9,0.8,2.3,1.5C30.2,24.4,35.8,34.1,35.8,34.2 M78.5,69.7V10.3c0-5.5-4.4-9.9-9.8-9.9H10.2c-5.4,0-9.8,4.4-9.8,9.9v59.4 c0,5.5,4.4,9.9,9.8,9.9h58.5C74.1,79.6,78.5,75.1,78.5,69.7",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXing);
export default __webpack_public_path__ + "static/media/Xing.1fc284a44e914dbd7a1e8e86d8282a54.svg";
export { ForwardRef as ReactComponent };